export default {
    h1: 'Cómo invita？',
    bgImg: 'https://web-data.zmlearn.com/image/inZxTEjuHfpkWyRqEiygtf/img_invite%E5%A4%87%E4%BB%BD%403x.png',
    left: [{
        i: '01',
        span: 'cuenta de Airclass a un amigo',
        links: ['Nuestros tutores', 'Cómo va', 'conviértase en un tutor', 'Descargar App']
    }, {
        i: '02',
        span: 'Compartir Airclass',
        spans: ['Compartir en Facebook', 'Enviar invitaciones', 'Compartir su link']
    }, {
        i: '03',
        span: 'Invite amigos, obtenga recompensa!',
        p: 'Ganar $10 por cada clase de prueba y $100 por cada pago de clase!'
    },],
    right: {
        h1: 'Obténga recompensa por cada recomendación de un amigo a Airclass',
        desc: 'En cuanto se registre su amigo: ',
        content: `
        Si el o ella asiste a la clase de prueba, va a obtener <strong>$10 como máximo</strong>,<strong>y $100</strong> si paga por nuestro curso.
       `,
        fb_btn: 'Compartir en Facebook',
        or: 'o',
        send: 'Enviar invitaciones',
        link: 'Compartir su link individual',
        history: 'Procedencia de recomendación',
        copied: 'Copied',
        copy: 'Copiar',
    },
    modal: {
        span1: 'Asistencia de la clase de prueba',
        span2: 'Pago válido',
        span3: 'Premios obtenidos',
        li: 'No ha invitado a ningún amigo',
    },
    alert: {
        warn1: 'Por favor agregue al menos un destinario',
        warn2: 'Por favor ingrese un correo correcto',
        success: 'Graicias! Ya le hemos enviado un correo de recomendación',
        success1: 'Copiado',
    }
}